import { restClient } from '@/Core'

import { NOTIFICATIONS_URL } from '../Helpers/notificationApi'
import { NotificationStore } from '../Stores/NotificationStore'

/**
 * Прочитати всі.
 *
 * ⚠️ Список після цього не перезавантажується, а позначається на місці.
 * Попередня версія після запиту кликала завантаження списку, а те, побачивши
 * піднятий самою ж задачею прапорець «вантажиться», виходило нічого не
 * зробивши: на сервері все прочитано, а в шухляді — ні, до наступного
 * відкриття.
 */
export const MarkAllNotificationsReadTask = async (): Promise<void> => {
    NotificationStore.setIsMarkingAll(true)

    try {
        await restClient.post(`${NOTIFICATIONS_URL}/all/change_is_readed`)
        NotificationStore.markAllRead()
    } catch (error) {
        console.warn('MarkAllNotificationsReadTask error:', error)
    } finally {
        NotificationStore.setIsMarkingAll(false)
    }
}
